<template>
  <ConfigProvider :locale="zh_CN">
    <slot></slot>
  </ConfigProvider>
</template>

<script>
import { ConfigProvider } from "ant-design-vue";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "LocaleProviderZh",
  components: {
    ConfigProvider,
  },
  data() {
    return {
      zh_CN,
    };
  },
};
</script>

<style lang="scss" scoped></style>
